import { MouseEvent } from 'react'
import { Button, FlexBox, RatingsStars } from '@vp/swan'

import { reviewsId } from '~/app/features/Gallery/components/Header/HeroHeader/components/RatingsSummary/constants'
import { scrollToElement } from '~/app/utils/scrollToElement'
import { useTranslations } from '~/app/features/Gallery/hooks/useTranslations'
import { RatingsSummaryProps } from '~/app/features/Gallery/components/Header/HeroHeader/components/RatingsSummary/interface'

export const RatingsSummary = ({ averageRating, reviewsCount }: RatingsSummaryProps) => {
  const localize = useTranslations()

  const handleScrollToReviews = (event: MouseEvent<HTMLButtonElement>): void => {
    event.preventDefault()

    scrollToElement(reviewsId, { behavior: 'smooth' })
  }

  return (
    <FlexBox alignItems="center" fontSize="small" className="ratings-summary">
      <Button aria-label={localize('ShowReviews')} skin="unstyled" onClick={handleScrollToReviews}>
        <RatingsStars ratingValue={averageRating} reviews={reviewsCount} />
      </Button>
    </FlexBox>
  )
}

RatingsSummary.displayName = 'RatingsSummary'
